export default "__VITE_ASSET__DCzXPGQK__"